import type { Threshold } from '@/domains/productDiscovery/ProductPage/common/modules/BulkPurchase/interfaces/BulkPurchase.model';

export const getBulkPurchaseThresholdIndex = (
  thresholds: Threshold[],
  quantity: number,
): number =>
  thresholds?.findIndex(
    (element) =>
      quantity >= element.minUnits &&
      (!element.maxUnits || quantity <= element.maxUnits),
  ) ?? -1;
